import { Form, Input } from 'antd';
import Box from 'components/Box';
import React from 'react';
import styled from 'styled-components';
import noteLabel from 'assets/note-label.png';

const InputNote = () => {
  return (
    <NoteBox style={noteContainerStyle}>
      <span className='note-label'><img src={noteLabel} alt="noteLabel" style={{ height: '26px', width: 'auto' }} /></span>
      <Form.Item noStyle name={'note'}>
        <Input.TextArea
          style={noteTextAreaStyle}
          placeholder=''
          rows={3}
        />
      </Form.Item>
    </NoteBox>
  );
};

export default InputNote;

const noteContainerStyle: React.CSSProperties = { display: 'flex', alignItems: 'flex-start', flexDirection: 'column', paddingBottom: 8 };
const noteTextAreaStyle: React.CSSProperties = { background: '#fdff9c93' };
const NoteBox = styled(Box)`
position: relative;
z-index: 1;
  .note-label {
    display: flex;
    z-index: 9;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    span {
      color: #1D2129;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px; /* 100% */
    }
  }
`;

